import { BACKGROUND_PROPERTIES, resizeBackgroundHandler } from './resize-background-handler';
import Template from '../../../../../banner_template/Template';
import { resizeLikeGridHandler } from "@frontend/group/modules/copy-and-resize/handlers/resize-like-grid-handler";
import { getObjectsForOrder } from '@frontend/group/modules/copy-and-resize';
import { FIELD_NAME_IMAGE_AREA } from '@frontend/constants/name-fields-of-template';
import {
  resizeProportionalTemplateHandler
} from '@frontend/group/modules/copy-and-resize/handlers/resize-proportional-template-handler';
import {updateDataForTemplate} from "@frontend/group/modules/copy-and-resize/helpers";
import {copyAndResizeEventBroker, EVENTS} from "@frontend/group/modules/copy-and-resize/event-broker";

export const TYPE_DIMENSION = {
  HIGH: 'high',
  PROPORTIONAL: 'proportional',
  BROAD: 'broad'
}

const MAP_STRATEGY_HANDLER = {
  [TYPE_DIMENSION.HIGH]: resizeLikeGridHandler,
  [TYPE_DIMENSION.PROPORTIONAL]: resizeProportionalTemplateHandler,
  [TYPE_DIMENSION.BROAD]: resizeLikeGridHandler
}


export const resizeTemplateHandler = (data) => {
    const {
      dimension,
      preview,
      state: {
        objects = getObjectsForOrder(preview.canvas.getObjects()),
        backgroundProperties = { 
          size: BACKGROUND_PROPERTIES.SIZE.COVER,
          position: BACKGROUND_PROPERTIES.POSITION.LEFT_AND_TOP,
          selectedField: objects.find(object => object.name === FIELD_NAME_IMAGE_AREA)?.id ?? null
        },
        alignContent,
        isUseDestinationTemplateFields = false,
      },
      isCopyObject = false
    } = data;
    const { id, data: templateSettings, canvas, template } = preview;
    const allObjects = canvas.getObjects();

    updateDataForTemplate({ id, dimension, template });

    const freshObjects = getObjectsForOrder(preview.canvas.getObjects())

    const _objects = objects
      .filter(object => object.id !== backgroundProperties.selectedField)
      .map(object => freshObjects.find(fresh => fresh.id === object.target.id)?.target);

    if (!MAP_STRATEGY_HANDLER[dimension.type]) {
      console.warn(`Type dimension [${dimension.type}] is not found`)
      return;
    }
  
    MAP_STRATEGY_HANDLER[dimension.type]({
      preview,
      isUseDestinationTemplateFields,
      templateSettings,
      mainTemplate: new Template(template),
      alignContent,
      isCopyObject,
      dimension,
      objects: _objects,
      canvas,
    });
    
    resizeBackgroundHandler({
      isCopyObject,
      dimension,
      object: allObjects.find(object => object.id === backgroundProperties.selectedField),
      backgroundProperties
    });

    canvas.requestRenderAll();
    
    copyAndResizeEventBroker.fire(EVENTS.PROGRESS, { dimension });
}
